module.exports = __webpack_public_path__ + "static/media/005.dd350b69.jpg";